function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Streetlight-Outage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "A.1.3-Mobile-Streetlight-Outage---View-Map-Loader",
  transform: "translate(-25.000000, -736.000000)",
  stroke: "#00148C"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 700.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "search",
  transform: "translate(25.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 2,
  transform: "translate(6.567466, 6.566900) rotate(-360.000000) translate(-6.567466, -6.566900) ",
  cx: 6.56746645,
  cy: 6.56689959,
  r: 5.2063335
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 10,
  x2: 14,
  y2: 14,
  id: "Path",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));

var SvgMapSearch = function SvgMapSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    className: "icon icon-map-search",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-search.f5b4ebf9.svg";
export { ForwardRef as ReactComponent };